import Tr from 'translations/Translations';

const createItem = (key) => ({
    value: key,
    label: Tr('espd_buyer_type_' + key),
});

export default [
    createItem('CLASSIC'),
    createItem('SECTOR')
]